import { createApis } from 'saga-slice-helpers';
import { API_TIMEOUT } from '../../constants';
import {
  getGraphApiSessionToken,
  getGraphApiSessionTokenExpiryDate,
  setGraphApiSessionToken,
  setGraphApiSessionTokenExpiryDate,
} from '../app/utils';
import graphAuthApi from './graphAuthApi';
import { returnMsGraphApi } from './utils';

const EXPIRY_BUFFER_MS = 5 * 60 * 1000;

const { api } = createApis({
  baseURL: returnMsGraphApi(),
  headers: {
    'Content-Type': 'application/json',
    ConsistencyLevel: 'eventual',
  },
  timeout: API_TIMEOUT,
});

async function searchUsers(searchTerm: string) {
  const selectFields = 'displayName,mail';
  const filters = `(endsWith(mail,\'ikea.com\') or endsWith(mail,\'ingka.com\')) and accountEnabled eq true`;

  const queryString = [
    `$search="displayName:${searchTerm}" OR "mail:${searchTerm}"`,
    `$filter=${filters}`,
    `$orderBy=displayName`,
    `$select=${selectFields}`,
  ].join('&');

  try {
    const response = await api.get(`/users?${queryString}`);
    return response.data.value;
  } catch (error) {
    console.error('graph api error:', error);
    return [];
  }
}

api.instance.interceptors.request.use(
  async (config) => {
    await fetchAndStoreGraphApiToken();

    const token = getGraphApiSessionToken();
    if (!token) {
      return;
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

async function fetchAndStoreGraphApiToken() {
  const token = getGraphApiSessionToken();
  const isTokenUpToDate = isGraphApiTokenUpToDate();

  if (token && isTokenUpToDate) {
    return;
  }

  const response = await graphAuthApi.get('/graph-api-token');

  if (response.status !== 200) {
    throw new Error('failed to obtain graph api token');
  }

  setGraphApiSessionToken(response.data?.accessToken);
  setGraphApiSessionTokenExpiryDate(response.data?.expiresOn);
}

function isGraphApiTokenUpToDate() {
  const tokenExpiryDate = getGraphApiSessionTokenExpiryDate();

  if (!tokenExpiryDate) {
    return false;
  }

  const currentTime = Date.now() + EXPIRY_BUFFER_MS;
  const expiryDate = new Date(tokenExpiryDate).getTime();

  return currentTime < expiryDate;
}

export { searchUsers };
